<template>
  <roe-modal
    wrap-class="drop-down-content"
    :is-open="true"
    :closeOnClickOutside="false"
    ref="section"
  >
    <roe-article-view ref="articleView"></roe-article-view>
    <section>
      <div class="section-header" @click="$refs.section.changeState()">
        <h2>Independent Research provides insight</h2>
        <button
          class="btn-secondary"
          @click.stop="open()"
          v-if="articles.length > 0"
        >
          Edit
        </button>
        <div class="drop-down-arrow"><!-- --></div>
      </div>
      <div class="section-content">
        <div class="pdf-add-wrap" v-if="articles.length === 0">
          <img src="@/assets/ico/ico-pdf-empty.svg" alt="" />
          <p>You can add up to 3 documents</p>
          <button class="btn-primary" @click.stop="open()">
            Add Documents
          </button>
        </div>
        <div class="col-grid" v-else>
          <div class="col" v-for="article in articles">
            <div class="research-providers">
              <img src="@/assets/ico/ico-pdf-big.svg" alt="" />
              <p>{{ article.bullet_point }}</p>
              <a href="#" @click.stop="$refs.articleView.open(article)"
                ><span>More info</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </roe-modal>
</template>

<script>
import RoeArticleView from "./ArticleView";
import RoeModal from "@/components/_shared/Modal";
import { FLASH_MESSAGE_SET_POSITION } from "@/store/mutations.type";
export default {
  name: "RoeArticleList",
  components: { RoeModal, RoeArticleView },
  props: {
    articles: {
      type: Array,
      required: true
    },
    articleForm: {
      required: true
    }
  },
  methods: {
    open() {
      this.$store.commit(FLASH_MESSAGE_SET_POSITION, "left bottom");
      this.articleForm.open();
    }
  }
};
</script>
